import React from 'react';
import { usePrompts } from '../context/PromptContext';
import { useToast } from '../context/ToastContext';
import { useButtonState } from '../hooks/useButtonState';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrash2, FiX, FiLayers, FiCheck, FiAlertCircle } = FiIcons;

const BulkActions = () => {
  const { selectedPrompts, deleteMultiplePrompts, clearSelection } = usePrompts();
  const { success: showSuccess, error: showError } = useToast();

  const {
    state: deleteState,
    error: deleteError,
    handleAction: handleDeleteAction,
    reset: resetDeleteState,
    icon: deleteIcon,
    text: deleteText,
    classes: deleteClasses,
  } = useButtonState({
    idleText: 'DELETE ALL',
    loadingText: 'Deleting...',
    successText: 'Deleted!',
    failedText: 'Failed',
    idleIcon: FiTrash2,
    onSuccess: () => {
      showSuccess(`${selectedPrompts.length} prompts deleted successfully!`);
      clearSelection();
    },
    onError: (error) => {
      const errorMsg = error.response?.data?.detail || error.message || 'Failed to delete prompts';
      showError(errorMsg);
    },
    autoResetDelay: 2000,
  });

  const handleBulkDelete = () => {
    if (window.confirm(`WARNING: This action cannot be undone.\n\nAre you sure you want to delete ${selectedPrompts.length} templates?`)) {
      handleDeleteAction(async () => {
        await deleteMultiplePrompts(selectedPrompts);
      });
    }
  };

  return (
    <div className="bg-neo-yellow border-2 border-black shadow-neo p-4 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center space-x-4">
        <div className="bg-black text-white p-2 border-2 border-white shadow-[2px_2px_0px_0px_rgba(0,0,0,0.2)]">
            <SafeIcon icon={FiLayers} size={24} />
        </div>
        <div>
            <h4 className="font-bold text-black uppercase">Batch Operations</h4>
            <span className="text-sm font-mono font-bold">
                {selectedPrompts.length} ITEM{selectedPrompts.length !== 1 ? 'S' : ''} SELECTED
            </span>
        </div>
      </div>
      
      <div className="flex items-center space-x-3 w-full sm:w-auto">
        <button
          onClick={handleBulkDelete}
          disabled={deleteState === 'loading'}
          className={`neo-btn neo-btn-danger flex-1 sm:flex-none flex items-center justify-center min-h-[44px] px-3 transition-all ${deleteClasses}`}
        >
          <SafeIcon icon={deleteState === 'loading' ? FiTrash2 : deleteIcon} size={16} className={`${deleteState === 'loading' ? 'animate-spin' : ''} mr-2 hidden sm:inline-block`} />
          <span className="hidden sm:inline">{deleteText}</span>
          <SafeIcon icon={deleteState === 'loading' ? FiTrash2 : deleteIcon} size={16} className="sm:hidden" />
        </button>

        <button
          onClick={clearSelection}
          className="neo-btn bg-white hover:bg-gray-100 flex-1 sm:flex-none flex items-center justify-center min-h-[44px] px-3"
        >
          <SafeIcon icon={FiX} className="mr-2 hidden sm:inline" size={16} />
          <SafeIcon icon={FiX} className="sm:hidden" size={16} />
          <span className="hidden sm:inline">CANCEL</span>
        </button>
      </div>
    </div>
  );
};

export default BulkActions;